import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router";

export default function DineOption() {
  const [restaurants, setRestaurants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [bookings, setBookings] = useState({});
  const [sortBy, setSortBy] = useState("rating");

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        const proxyServer = "https://cors-anywhere.herokuapp.com/";
        const swiggyAPI =
          "https://www.swiggy.com/dapi/restaurants/list/v5?lat=28.7040592&lng=77.10249019999999&is-seo-homepage-enabled=true";
        const response = await fetch(proxyServer + swiggyAPI);
        const data = await response.json();
        const list = data?.data?.cards[1]?.card?.card?.gridElements?.infoWithStyle?.restaurants ?? [];
        setRestaurants(list);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, []);

  const topRestaurants = useMemo(() => {
    const list = [...restaurants];
    if (sortBy === "rating") {
      return list
        .sort((a, b) => (Number(b?.info?.avgRating) || 0) - (Number(a?.info?.avgRating) || 0))
        .slice(0, 8);
    }
    return list
      .sort((a, b) => (Number(a?.info?.sla?.deliveryTime) || 999) - (Number(b?.info?.sla?.deliveryTime) || 999))
      .slice(0, 8);
  }, [restaurants, sortBy]);

  const toggleBooking = (id) =>
    setBookings((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));

  return (
    <section className="w-[92%] max-w-6xl mx-auto mt-14 pb-16">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="text-2xl sm:text-3xl font-bold">Discover best restaurants on Dineout</p>
        <div className="flex items-center gap-3">
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            className="rounded-xl border border-gray-300 px-3 py-2 bg-white text-sm"
          >
            <option value="rating">Top Rated</option>
            <option value="delivery">Fastest Nearby</option>
          </select>
          <Link to="/dineout" className="text-[#ff5200] font-semibold">
            View all
          </Link>
        </div>
      </div>

      {loading ? (
        <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={index} className="h-60 rounded-2xl bg-gray-200 animate-pulse"></div>
          ))}
        </div>
      ) : (
        <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {topRestaurants.map((item) => {
            const id = item?.info?.id;
            const isBooked = bookings[id];
            return (
              <article key={id} className="rounded-2xl border border-gray-200 p-3 bg-white">
                <img
                  className="w-full h-36 object-cover rounded-xl"
                  src={"https://media-assets.swiggy.com/swiggy/image/upload/" + item?.info?.cloudinaryImageId}
                  alt={item?.info?.name || "Restaurant"}
                />
                <h3 className="mt-3 font-semibold h-12 overflow-hidden">{item?.info?.name}</h3>
                <p className="text-sm text-gray-500 h-10 overflow-hidden">{item?.info?.cuisines?.join(", ")}</p>
                <p className="text-sm mt-1">
                  <span className="font-semibold text-green-700">{item?.info?.avgRating || "N/A"}</span>
                  <span className="mx-2">|</span>
                  <span className="text-gray-600">{item?.info?.areaName}</span>
                </p>
                <div className="mt-3 flex gap-2">
                  <button
                    onClick={() => toggleBooking(id)}
                    className={`flex-1 rounded-xl py-2 text-sm font-semibold border transition ${
                      isBooked
                        ? "bg-green-600 text-white border-green-600"
                        : "border-[#ff5200] text-[#ff5200] hover:bg-orange-50"
                    }`}
                  >
                    {isBooked ? "Table Booked" : "Book Table"}
                  </button>
                  <Link
                    to={`/city/delhi/${id}`}
                    className="rounded-xl px-3 py-2 text-sm border border-gray-300 text-gray-700 hover:bg-gray-100"
                  >
                    Menu
                  </Link>
                </div>
              </article>
            );
          })}
        </div>
      )}
    </section>
  );
}
